import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'currentUser';

export type Tokens = { access_token: string, refresh_token?: string };

interface StorageImpl {
  setItem(key: string, value: string): void
  getItem(key: string): string | null
  removeItem(key: string): void
  clear(): void
}

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private readonly platform = inject(PLATFORM_ID);
  private readonly storage: StorageImpl;

  constructor() {
    if (isPlatformBrowser(this.platform)) {
      this.storage = localStorage
    } else {
      this.storage = {
        setItem(key, value) {

        },
        getItem(key) {
          return null
        },
        removeItem(key) {

        },
        clear() {

        },
      }
    }
  }

  signOut(): void {
    this.clear()
  }

  public saveTokens(token: Tokens): void {
    this.set(TOKEN_KEY, token);
  }

  public getTokens(): Tokens {
    return this.get(TOKEN_KEY);
  }

  public saveUser(user: any): void {
    this.set(USER_KEY, user);
  }

  public getUser(): any {
    return this.get(USER_KEY) || {};
  }





  public set(key: string, value: any) {
    this.storage.setItem(key, JSON.stringify(value));
  }

  public get(key: string) {
    const value = this.storage.getItem(key) || '';

    try {
      return JSON.parse(value)
    } catch (e) {
      return value;
    }
  }

  public remove(key: string) {
    this.storage.removeItem(key);
  }

  public clear() {
    this.storage.clear();
  }
}
